<template>

    <FloatingPanel
        :title="title"
        :saveable="false"
    >

        <div class="canvas::editor-website-editors-loop-LoopPanel">

            <Tabs :tabs="tabs">

                <div slot="Algemeen">

                    <SwitchInput
                        label="Aantal kolommen"
                        instruction="Kies hier het aantal kolommen per rij."
                        :items="[
                            { value: 2 },
                            { value: 3 },
                            { value: 4 },
                        ]"
                        :options="options"
                        :defaultValue="3"
                        options-property="columnsCount"
                        :open="true"
                    />

                    <SwitchInput
                        label="Toon icoon? (of nee = toon afbeelding)"
                        :options="options"
                        options-property="iconOrImage"
                        :items="[
                            { value: '1', label: 'Ja'},
                            { value: '0', label: 'Nee'},
                        ]"
                        defaultValue="1"
                        :open="true"
                        @valueChange="checkTabs"
                    />

                    <accordion-input :open="true">
                        <template #label>

                            <div class="font-medium text-gray-600">Icoon/Afbeelding grootte (hoogte)</div>

                        </template>
                        <template #content>

                            <select v-model="options.iconHeight" 
                                class="w-full px-4 py-2 mb-3 border border-gray-300 rounded-md"
                            >
                                <option value="w-8 h-8 text-[2rem]">Klein</option>
                                <option value="w-12 h-12 text-[3rem]">Normaal</option>
                                <option value="w-16 h-16 text-[4rem]">Middel groot</option>
                                <option value="w-24 h-24 text-[6rem]">Groot</option>
                                <option value="w-32 h-32 text-[8rem]">Extra groot</option>
                            </select>

                        </template>
                    </accordion-input>

                    <SwitchInput
                        label="Icoon/afbeelding positionering"
                        :options="options"
                        options-property="iconAlignment"
                        :items="[
                            { value: 'left', label: 'Links'},
                            { value: 'center', label: 'Midden'},
                            { value: 'right', label: 'Rechts'},
                        ]"
                        defaultValue="center"
                        :open="true"
                    />
                    
                </div>

                <div slot="Icoon" v-if="options.iconOrImage == 1">

                    <ColorsInput
                        label="Icoon kleur"
                        instruction="Bepaal hier de kleur van het icoon."
                        :colors="colors"
                        :options="options"
                        options-property="iconColor"
                        :open="true"
                    />

                    <ColorsInput
                        label="Achtergrond icoon kleur"
                        instruction="Bepaal hier de kleur van de achtergrond van de huidige icoon."
                        :colors="colors"
                        :options="options"
                        options-property="iconBackgroundColor"
                        :open="true"
                    />

                    <accordion-input :open="false">
                        <template #label>

                            <div class="font-medium text-gray-600">Border / Rand</div>

                        </template>
                        <template #content>

                            <SwitchInput
                                label="Toon rand"
                                instruction=""
                                :options="options"
                                options-property="iconShowBorder"
                                :items="[
                                    { value: 'uit', label: 'Uit'},
                                    { value: 'aan', label: 'Aan'},
                                ]"
                                defaultValue="uit"
                                :accordion="false"
                                :spacing="{'horizontal': false, 'vertical': true}"
                            />

                            <div class="mt-2 mb-3 font-medium text-gray-600">Rand stijl</div>
                            <select v-model="options.iconBorderSize" class="px-4 py-2 mb-3 border border-gray-300 rounded-md">
                                <option value="1px" selected>1px</option>
                                <option value="2px">2px</option>
                                <option value="3px">3px</option>
                                <option value="4px">4px</option>
                            </select>

                            <select v-model="options.iconBorderStyle" class="px-4 py-2 mb-3 border border-gray-300 rounded-md">
                                <option value="solid" selected>Solid</option>
                                <option value="dotted">Dotted</option>
                                <option value="dashed">Dashed</option>
                                <option value="double">Double</option>
                            </select>

                            <div class="mt-2 mb-2 font-medium text-gray-600">Rand afronding</div>
                            <small class="block mb-3 text-gray-500">Kies hier de afronding van de card.
                                Dit gebeurt ook als de rand optie uit staat.
                            </small>
                            <select v-model="options.iconBorderRounded" class="w-full px-4 py-2 mb-3 border border-gray-300 rounded-md">
                                <option value="rounded-none" selected>Geen</option>
                                <option value="rounded-sm">Klein</option>
                                <option value="rounded">Normaal</option>
                                <option value="rounded-lg">Groot</option>
                                <option value="rounded-xl">XL</option>
                                <option value="rounded-2xl">XXL</option>
                                <option value="rounded-3xl">3XL</option>
                                <option value="rounded-full">Volledig rond</option>
                            </select>

                            <ColorsInput
                                label="Randkleur"
                                instruction="Bepaal hier de kleur van de rand van de button."
                                :colors="colors"
                                :options="options"
                                options-property="iconBorderColor"
                                :accordion="false"
                                :spacing="{ 'horizontal': false, 'vertical': true }"
                            />

                        </template>
                    </accordion-input>
                </div>

            </Tabs>
        </div>

        <template v-slot:actions>
            
            <div class="flex">
                <button class="btn btn-success justify-center w-full !rounded-none" @click="save">
                    <i class="mr-1 fa fa-save"></i> Opslaan
                </button>

                <button
                    class="btn btn-blue !rounded-none justify-center w-full"
                    @click="addItem"
                >
                    <i class="mr-1 fa fa-plus"></i> Item toevoegen
                </button>
            </div>

        </template>

    </FloatingPanel>

</template>

<script>

import LoopPanel from "galaxy/modules/Canvas/resources/js/editor/website/editors/loop/LoopPanel";
import FloatingPanel from "galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import SwitchInput from "galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import ColorsInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/ColorsInput";
import AccordionInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input";
import getDatabaseColors from "@galaxy/modules/Canvas/resources/components/canvas/blocks/utils/text/admin/getDatabaseColors";

export default {

    extends: LoopPanel,

    components: {
        FloatingPanel,
        SwitchInput,
        AccordionInput,
        Tabs,
        ColorsInput,
    },

    created() {
        this.checkTabs();
    },

    async mounted() {
        await this.loadColors();
    },

    data() {
        return {
            targets: {
                '_self': 'Huidige pagina',
                '_blank': 'Nieuwe pagina',
            },
            colors: null,
            tabs: [
                'Algemeen',
                'Icoon',
            ]
        };
    },

    methods: {

        checkTabs() {
            if (this.options.iconOrImage == 1) {
                this.tabs = [
                    'Algemeen',
                    'Icoon',
                ]
            } else {
                this.tabs = [
                    'Algemeen',
                ]
            }
        },

        async loadColors() {
            // Grab database colors
            let databaseColors = (await getDatabaseColors(true)).data;

            // Initialize empty array
            this.colors = [
                'transparent',
                'white',
                'black',
            ];

            // Add colors from database to array
            $.each(databaseColors, (item, value) => {
                if (typeof value !== 'string') {
                    this.colors.push(...Object.values(value));
                } else {
                    this.colors.push(value);
                }
            })

            this.colors = _.uniq(this.colors);

            let formattedColors = {};

            for (const color of this.colors) {
                if (typeof color === 'object') {
                    for (const [key, value] of Object.entries(color)) {
                        formattedColors[key] = value;
                    }
                } else {
                    formattedColors[color] = color;
                }
            }

            this.colors = formattedColors;
        },

    },

}

</script>

<style lang="scss" scoped>


</style>
